import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import {
  IncomeCheckResponse,
  NoUserService,
} from '@app/service/no-user-service/no-user.service';
import { StateService } from '@app/service/state/state.service';
import { StandardCheckoutResponse } from '@app/service/user-service/user.service';
import { ListOption } from 'web-component-library/projects/component-library/src/public-api';

@Component({
  selector: 'no-salary-check',
  templateUrl: './no-salary-check.component.html',
  styleUrls: ['../../page-shared.css', './no-salary-check.component.scss'],
})
export class NoSalaryCheckComponent extends RouteComponent implements OnInit {
  loading = true;
  navigationInProgress = false;
  sliderAsInput = false;
  showError = false;
  hideSlider = true;
  form: FormGroup;
  roundedMonthlyIncome: number;
  sliderBracketSize: number;

  sliderAnswer: number;
  sliderSalaryAnswers: ListOption[];

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private noUserService: NoUserService,
    private formBuilder: FormBuilder
  ) {
    super(router, route, stateService, headerService);
  }

  async ngOnInit() {
    try {
      let resp: IncomeCheckResponse =
        await this.noUserService.getLatestAnnualNetIncome();
      if (
        !!resp &&
        !!resp.latestAnnualNetIncome &&
        resp.latestAnnualNetIncome.amount > 0
      ) {
        this.hideSlider = false;
        this.calculateRoundedMonthlyIncome(resp.latestAnnualNetIncome.amount);
        this.setupSlider();
        this.sliderAsInput = true;
      }
    } catch (err) {
      this.handleError(err);
    }

    this.setupForm();
    this.loading = false;
  }

  calculateRoundedMonthlyIncome(annualNetIncome: number): void {
    let monthlyNetIncome = Math.round(annualNetIncome / 12);
    let amountNumbers = monthlyNetIncome.toString().length;
    this.sliderBracketSize = 10 ** (amountNumbers - 2);

    this.roundedMonthlyIncome =
      Math.round(monthlyNetIncome / this.sliderBracketSize) *
      this.sliderBracketSize;
  }

  setupSlider(): void {
    this.sliderSalaryAnswers = new Array(9);
    let middle = Math.floor(this.sliderSalaryAnswers.length / 2);

    for (let i = 0; i < this.sliderSalaryAnswers.length; i++) {
      let distance = middle - i;
      let bracketMin =
        this.roundedMonthlyIncome - distance * this.sliderBracketSize;

      this.sliderSalaryAnswers[i] = {
        label: `kr ${(bracketMin + 1).toLocaleString().replace(',', ' ')} - ${(
          bracketMin + this.sliderBracketSize
        )
          .toLocaleString()
          .replace(',', ' ')}`,
        value: bracketMin,
      };
    }
  }

  setupForm(): void {
    this.form = this.formBuilder.group({
      formAnswer: [
        this.roundedMonthlyIncome || '',
        [Validators.required, Validators.pattern('^[0-9]+$')],
      ],
    });
  }

  toggleInput() {
    this.sliderAsInput = !this.sliderAsInput;
  }

  async handleCtaClick() {
    if (this.form.valid || this.sliderAsInput) {
      this.navigationInProgress = true;
      try {
        let resp: StandardCheckoutResponse =
          await this.noUserService.applyForLoan(
            this.sliderAsInput ? this.sliderAnswer : this.form.value.formAnswer
          );

        if (resp.success) {
          this.navigate();
        }
      } catch (err) {
        this.navigationInProgress = false;
        this.handleError(err);
      }
    } else {
      this.navigationInProgress = false;
      this.showError = true;
    }
  }
}
